import axios from "axios";
import store from "@/store";
import debounce from "@/utils/debounce";
import { Loading, Message } from "element-ui";
import Router from "@/router";
import queryParams from "@/utils/queryParams";

axios.defaults.timeout = 900000; // 设置超时
axios.defaults.headers["Content-Type"] = "application/json;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    const { companyUuid, token } = store.state.user?.user || {};
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    if (companyUuid) config.headers["companyUuid"] = companyUuid;
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.resolve(error?.response || {})
);

// loading 状态使用 Vuex 控制
const showLoading = () => {
  store.dispatch("app/showLoading");
};

const hideLoading = () => {
  store.dispatch("app/hideLoading");
};
let hasShown401Message = false;
// 状态码检查
function checkStatus(response, showMseeage) {
  const { status, data } = response;
  console.log('======status=======>',status)
  if (status === 401) {
    store.dispatch("user/logout");
    store.dispatch("userLog/clearUserLog");
    if (!hasShown401Message) {
      hasShown401Message = true;
      Message({
        message: data?.msg || "登录过期，请重新登录",
        type: "warning",
      });
      Router.push({path:'/login'})
      // 5秒后恢复允许提示
      setTimeout(() => {
        hasShown401Message = false;
      }, 5000);
    }
    return Promise.reject(data);
  }
  console.log('======data=======>',status >= 200 && status < 300)
  if (status >= 200 && status < 300) {
    return {
      status:200,
      data: data,
      info: data?.msg || "成功",
    };
  }

  showMseeage && Message.error(data?.msg || "请求异常");
  return Promise.reject({
    status,
    data: data,
    info: data?.msg || "请求失败",
  });
}

// 请求方法封装
const request = async (options, showLoad = true, showMseeage) => {
  try {
    if (showLoad) showLoading();
    const response = await axios(options);
    return await checkStatus(response, showMseeage);
  } catch (error) {
    return Promise.reject(error);
  } finally {
    if (showLoad) hideLoading();
  }
};

// 导出统一调用方法
export default {
  get(url, params = {}, showLoad = true,showMseeage = true) {
    return request(
      {
        method: "get",
        url: url + queryParams(params),
      },
      showLoad,
      showMseeage
    );
  },

  post(url, data = {}, showLoad = true,showMseeage = true) {
    return request(
      {
        method: "post",
        url,
        data,
      },
      showLoad,
      showMseeage
    );
  },

  put(url, data = {}, showLoad = true,showMseeage = true) {
    return request(
      {
        method: "put",
        url,
        data,
      },
      showLoad,
      showMseeage
    );
  },

  delete(url, data = {}, showLoad = true,showMseeage = true) {
    return request(
      {
        method: "delete",
        url,
        data,
      },
      showLoad,
      showMseeage
    );
  },

  upload(url, formData, showLoad = true,showMseeage = true) {
    return request(
      {
        method: "post",
        url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      showLoad,
      showMseeage
    );
  },
};
